import React from "react";
import "../Accessories/Accessories.css";

const Accessories = (props) => {
  return (
    <div className="bg-text">
      <div className="container">
        <form action="#" method="post">
          <div className="row">
            <div className="col-sm">
              <select
                value={props.brandSelectedValue}
                onChange={props.ddlBrandOnChange}
                className={`form-control search-slt ${props.errors && props.errors.brandError ? "invalid-home" : ""}`}
                name="ddlBrand"
              >
                <option key="brandSelected" value="">
                  Select Brand
                </option>
                {props.brandData.length &&
                  props.brandData.map((model) => (
                    <option key={model.value} value={model.value}>
                      {model.text}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm">
              <select
                value={props.vacuumModelSelectedValue}
                onChange={props.ddlVacuumModeOnChange}
                className={`form-control search-slt ${props.errors && props.errors.vacuumModelError ? "invalid-home" : ""}`}
                name="ddlVacuumModel"
              >
                <option key="modelSeriesSelected" value="">
                  Select Vacuum Model
                </option>
                {props.vacuumModelData.length &&
                  props.vacuumModelData.map((model) => (
                    <option key={model.value} value={model.value}>
                      {model.text}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm">
              <select
                value={props.modelSeriesSelectedValue}
                onChange={props.ddlModelSeriesOnChange}
                className={`form-control search-slt ${props.errors && props.errors.modelSeriesError ? "invalid-home" : ""}`}
                name="ddlModelSeries"
              >
                <option key="modelSeriesSelected" value="">
                  Select Vacuum Model Series
                </option>
                {props.modelSeriesData.length &&
                  props.modelSeriesData.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.text}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-sm">
              <button
                type="button"
                className="btn btn-lg btn-lg-width"
                onClick={props.handleClick}
              >
                Search
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Accessories;
